import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['category', 'noTagsWarning', 'tag']

  connect() {
    // Give category_checkbox_picker time to connect and disable checkboxes
    setTimeout(this.toggleTags.bind(this), 100)
  }

  selectableTags() {
    return this.tagTargets.filter(tag => {
      return this.isTagSelectable(tag)
    })
  }

  toggleTags() {
    this.tagTargets.forEach(tag => {
      if (this.isTagSelectable(tag)) {
        this.show(tag)
      } else {
        this.hide(tag)
      }
    })

    if (this.hasNoTagsWarningTarget) {
      if (this.selectableTags().length === 0) {
        this.show(this.noTagsWarningTarget)
      } else {
        this.hide(this.noTagsWarningTarget)
      }
    }
  }

  hide(element) {
    element.classList.add('d-none')
    element.querySelectorAll('input').forEach(input => {
      input.disabled = true
    })
  }

  isTagSelectable(tag) {
    const selectedCategories = this.categoryTargets.filter(category => category.checked && !category.disabled)
    const categoryIds = selectedCategories.map(category => parseInt(category.value, 10))
    const candidateCategoryIds = JSON.parse(tag.dataset.forCategory)

    return candidateCategoryIds.some(id => categoryIds.includes(id))
  }

  show(element) {
    element.classList.remove('d-none')
    element.querySelectorAll('input').forEach(input => {
      input.disabled = false
    })
  }
}
